module.exports = __webpack_public_path__ + "img/health_metrics_filled.6b0ca68e.svg";